/* eslint no-invalid-this: "off" */
import $ from 'jquery'
import LayoutContentResizer from 'modules/layoutContentResizer'
import Analytics from 'libraries/analytics'
import Deferred from 'libraries/deferred'

var setupNavigationModule = function (module, ModuleController) {
  module.addInitializer(function () {
    this._createController();
  });

  module.addFinalizer(function () {
    this._closeController();
  });

  module.show = function () {
    this.controller.show();
  };

  module.hide = function () {
    this.controller.hide();
  };

  module._createController = function () {
    const userTimingLoad = Deferred.build();
    Analytics.userTiming(
      'moduleControllerLoaded:' + module.moduleName,
      userTimingLoad
    );
    this.controller = new ModuleController();
    // sync init of controller
    if (this.controller.loadedAfterInit()) {
      module._controllerLoaded();
      userTimingLoad.resolve();
    }
    // async init of controller
    this.listenTo(this.controller, 'loaded', module._controllerLoaded);
    this.listenTo(this.controller, 'loaded', userTimingLoad.resolve);
    this.listenTo(this.controller, 'loadFailed', module._controllerLoadFailed);
  }

  module._addViewToDOM = function () {
    $('#container-content').append(this.controller.view.el);
    LayoutContentResizer.resizeContent();
    this.hide();
  };

  module._closeController = function () {
    this.controller.close();
    delete this.controller;
  };

  module._controllerLoaded = function () {
    module._addViewToDOM();
    module.trigger('loaded');
  };

  module._controllerLoadFailed = function (reason) {
    module.trigger('loadFailed', reason);
  };
};

export default setupNavigationModule;

